import React, { useCallback } from "react"
import { useDispatch } from "react-redux"
import { createErrorMsgStructure, validateArrayCustom } from "../../Helper/index"
import { updateValidationErrors } from "../reducer/validationSlice"


export const useValidateRepeatableElement = (tabName,fieldPattern) => { 
     const dispatch=useDispatch()
    const validateError=useCallback((reducerName,tableName,errorDisplayName)=>(dispatch,getState)=>{
        if(!errorDisplayName || typeof fieldPattern()[tabName][tableName]!="object")
            throw "invalid params"

        let errorList = validateArrayCustom(getState()[reducerName][tableName],fieldPattern()[tabName][tableName], createErrorMsgStructure(errorDisplayName))
        return errorList
    },[fieldPattern])
  
    const updateErrors=useCallback((errors,errorKeys)=>dispatch(updateValidationErrors({tabName,errors,errorKeys})),[tabName])
    return React.useMemo(()=>({validateError,updateErrors}),[validateError,updateErrors])
    
}